import { tabRegistry } from "../tab-registry"

export const LAUNCHER_HREF = "/launcher.html"
export const LAUNCHER_TARGET = "spaestiem-launcher"
export const LAUNCHER_FEATURES = "popup=yes,width=320,height=480"

export function openOrFocusLauncher(): void {
  tabRegistry.openOrFocus(LAUNCHER_HREF, LAUNCHER_TARGET, LAUNCHER_FEATURES)
}
